import { Link } from 'react-router-dom';
import { MONTHLY_PLANS } from './pricingData';

// 요금 페이지(/price)와 메인 페이지 요금 섹션이 함께 쓰는 월 요금표 + 안내 문구
export default function MonthlyPlanTable() {
  return (
    <>
      <div className="price-table-wrap reveal">
        <table className="price-table">
          <thead>
            <tr>
              <th>인원</th>
              <th>
                성도용 앱(기본)
                <br />
                PC 관리자
              </th>
              <th>관리자 앱</th>
              <th>교적부 앱</th>
              <th>재정 앱</th>
              <th>주일학교 앱</th>
            </tr>
          </thead>
          <tbody>
            {MONTHLY_PLANS.map(([people, base, adminRoll, financeSs]) => (
              <tr key={people}>
                <td>{people}</td>
                <td>{base}</td>
                <td>{adminRoll}</td>
                <td>{adminRoll}</td>
                <td>{financeSs}</td>
                <td>{financeSs}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="price-table-wrap price-extra-wrap reveal">
        <table className="price-table price-extra-table">
          <thead>
            <tr>
              <th>항목</th>
              <th>안내</th>
              <th>비용</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>등록 기본요금</td>
              <td className="extra-desc">모든 서비스 플랜 공통</td>
              <td className="cost-cell">100,000원 (신청시)</td>
            </tr>
            <tr>
              <td>갤러리 용량</td>
              <td className="extra-desc">성도용 앱 갤러리 기본 10GB 제공</td>
              <td className="cost-cell">10GB 추가당 1,000원</td>
            </tr>
            <tr>
              <td>개발자 계정</td>
              <td className="extra-desc">
                구글·애플 개발자 계정 (별도 부담)
                <Link to="/developer-account-guide" className="extra-guide-btn">
                  등록 안내 보기 →
                </Link>
              </td>
              <td className="cost-cell">
                약 월 11,000원
                <small>
                  구글 - 최초 1회 $25
                  <br />
                  애플 - 년 $99
                </small>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
